export default "__VITE_ASSET__BCVr9Lzf__"